import type { ExceptionField } from '@/api/cockpit';

export function isCustomerAccountField(field: ExceptionField): boolean {
  return field.key === 'customer_number' || field.key === 'invoice_customer_number';
}
